"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.form.title.edit': 'Edytuj Firmę',
    'company.form.title.add': 'Dodaj Firmę',
    'company.form.back': 'Wstecz',
    'company.form.name.label': 'Nazwa Firmy',
    'company.form.name.placeholder': 'Wprowadź nazwę firmy',
    'company.form.nip.label': 'NIP',
    'company.form.nip.placeholder': '123-456-78-90',
    'company.form.email.label': 'Email',
    'company.form.email.placeholder': 'adres@email.com',
    'company.form.phone.label': 'Telefon',
    'company.form.phone.placeholder': '123 456 789',
    'company.form.address.label': 'Adres',
    'company.form.street.placeholder': 'Ulica i numer',
    'company.form.postal_code.placeholder': 'Kod pocztowy',
    'company.form.city.placeholder': 'Miasto',
    'company.form.website.label': 'Strona internetowa',
    'company.form.website.placeholder': 'https://firma.com',
    'company.form.description.label': 'Opis',
    'company.form.description.placeholder': 'Opis firmy',
    'company.form.active.label': 'Aktywna',
    'company.form.logo.label': 'Logo Firmy',
    'company.form.logo.placeholder': 'Wybierz logo firmy',
    'company.form.submit.update': 'Aktualizuj',
    'company.form.submit.create': 'Zapisz',
    'company.form.submit.createCompanyData': 'Zapisz Dane Firmy',
    'company.form.acl.loadError': 'Błąd ładowania metadanych ACL:',
    'company.form.load.error': 'Błąd ładowania firmy',
    'company.form.submit.updateError': 'Błąd aktualizacji firmy',
    'company.form.submit.createError': 'Błąd tworzenia firmy',
    'company.form.submit.updateSuccess': 'Firma została pomyślnie zaktualizowana',
    'company.form.submit.createSuccess': 'Firma została pomyślnie utworzona',
};
